import styled from 'styled-components';

export const BackButtonStyle = styled.div`
    border: 0;
    background: ${({ theme }) => theme.palette.grayLighter.main};
    position: absolute;
    top: 20px;
    margin-bottom: 40px;
    width: auto;
    border-radius: 28px;
`;
